import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAlUn4JqZvj2a6KQYHmwjA4tyPDuE5iplI",
  authDomain: "flamo-pay.firebaseapp.com",
  projectId: "flamo-pay",
  storageBucket: "flamo-pay.appspot.com",
  messagingSenderId: "701558481538",
  appId: "1:701558481538:web:01b7436e7f609aa6020a9b",
  measurementId: "G-LKL7WFM75Z",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
const auth = getAuth(app);

const VAPID_KEY = "BPf2QjmAGjmQpk5ZnHxTylEvgDUOvG5DqXOxlHGSbFelp0-i3bsT9Ko-8n9Cr3iZSnAELs_xn1v44_dDqdu-K58";
const BACKEND_URL = "https://flamo-pay.onrender.com"; // ✅ Your live server

export const requestPermission = async () => {
  console.log("🔔 Requesting notification permission...");
  const permission = await Notification.requestPermission();

  if (permission !== "granted") {
    console.warn("❌ Notifications not granted by the user");
    return;
  }

  try {
    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    console.log("✅ FCM Token:", token);

    // Wait for Firebase Auth state
    onAuthStateChanged(auth, async (user) => {
      const userId = user ? user.uid : localStorage.getItem("userId") || "guest";
      console.log(`📱 Saving token for user: ${userId}`);

      await fetch(`${BACKEND_URL}/api/save-token`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, token }),
      });
    });
  } catch (error) {
    console.error("⚠️ Error during token registration:", error);
  }
};

// Listen for foreground notifications
onMessage(messaging, (payload) => {
  console.log("📩 Foreground message received:", payload);
  const { title, body, image } = payload.notification || {};
  new Notification(title || "FlamoPay", {
    body: body || "You have a new notification.",
    icon: image || "/icon.png",
  });
});

export default app;
